import { mapGetters } from 'vuex';
import { storage } from '@/utils/storage';
import IconInstagram from '@/components/icons/IconInstagram.vue';
import IconFacebook from '@/components/icons/IconFacebook.vue';
import IconFacebookFill from '@/components/icons/IconFacebookFill.vue';
import IconVisa from '@/components/icons/IconVisa.vue';
import IconMasterCard from '@/components/icons/IconMasterCard.vue';
import IconLiqpay from '@/components/icons/IconLiqpay.vue';
import IconYouTube from '@/components/icons/IconYouTube.vue';

export default {
  name: 'Footer',
  data() {
    return {
      showIosAppPopup: false,
      showAndroidAppPopup: false,
      showOpSystemPopUp: false
    };
  },
  components: {
    IconYouTube,
    IconLiqpay,
    IconMasterCard,
    IconVisa,
    IconFacebookFill,
    IconFacebook,
    IconInstagram
  },

  mounted() {
    // this.getMobileOperatingSystem();
  },
  computed: {
    ...mapGetters({
      contacts: 'setting/variables',
      headerMenu: 'setting/headerMenu',
      isDistributor: 'profile/isDistributor',
      isProfessional: 'profile/isProfessional'
    }),
    documents() {
      return this.contacts?.documents ? this.contacts.documents : {};
    },
    phones() {
      let list = [];
      if (this.contacts?.contacts) {
        list = ['phone1', 'phone2', 'phone3'].reduce((acc, key) => {
          let item = this.contacts.contacts[key];
          return item ? [...acc, item] : acc;
        }, []);
      }

      return list;
    }
  },
  methods: {
    /**
     * @param {keyof GeneralContacts|string} field
     * @return {string}
     */
    closeAppPopup() {
      this.showOpSystemPopUp = false;
    },
    getMobileOperatingSystem() {
      if (!storage.getItem('userMobileOperatingSystem')) {
        let userAgent = navigator.userAgent || navigator.vendor || window.opera;
        let userMobileOperatingSystem;

        if (/android|Android/i.test(userAgent)) {
          userMobileOperatingSystem = 'Android';
        }
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
          userMobileOperatingSystem = 'iOS';
        }
        if (!(/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) && !/android|Android/i.test(userAgent)) {
          return (userMobileOperatingSystem = undefined);
        }
        if (userMobileOperatingSystem) {
          if (userMobileOperatingSystem === 'iOS') {
            storage.setItem('userMobileOperatingSystem', userMobileOperatingSystem);
            setTimeout(() => {
              this.showOpSystemPopUp = true;
              this.showIosAppPopup = true;
            }, 3000);
          }
          if (userMobileOperatingSystem === 'Android') {
            setTimeout(() => {
              this.showOpSystemPopUp = true;
              this.showAndroidAppPopup = true;
            }, 3000);
          }
        }
      }
    },
    getContact(field) {
      return this.contacts?.contacts[field] || '';
    }
  }
};
